import React from 'react';
import PropTypes from 'prop-types';

import Card from 'bundles/apex/card';

export default function DealFormCard({ children, ...props }) {
  return (
    <Card {...props}>
      <div className="form form-horizontal">
        {children}
      </div>
    </Card>
  );
}

DealFormCard.propTypes = {
  children: PropTypes.node.isRequired,
};
